export const REGISTRATION_NUMBER = {
    ALB: 'Numri i regjistrimit të kompanisë',
    AND: 'Número de registre de comerç',
    ARE: 'رقم التسجيل التجاري',
    AUT: 'Firmenbuchnummer',
    BEL: 'Numéro d\'entreprise',
    BGR: 'ЕИК',
    BIH: 'ID broj',
    CHE: 'Handelsregisternummer',
    CYP: 'Αριθμός Εγγραφής Εταιρείας',
    CZE: 'IČO',
    DEU: 'Handelsregisternummer',
    DNK: 'CVR-nummer',
    DZA: 'Numéro de registre du commerce',
    EGY: 'رقم السجل التجاري',
    ESP: 'Número de registro mercantil',
    EST: 'Registrikood',
    FIN: 'Y-tunnus',
    FRA: 'Numéro SIRET',
    GBR: 'Company Registration Number',
    GRC: 'Αριθμός ΓΕΜΗ',
    HRV: 'MBS',
    HUN: 'Cégjegyzékszám',
    IRL: 'Company Number',
    ITA: 'Numero di iscrizione al Registro delle Imprese',
    JOR: 'رقم التسجيل التجاري',
    LIE: 'Handelsregisternummer',
    LTU: 'Įmonės kodas',
    LUX: 'Numéro de Registre de Commerce',
    LVA: 'Reģistrācijas numurs',
    MAR: 'Numéro de registre du commerce',
    MCO: 'Numéro d\'immatriculation',
    MKD: 'Матичен број',
    MLT: 'Company Registration Number',
    MNE: 'Matični broj',
    NLD: 'KvK-nummer',
    NOR: 'Organisasjonsnummer',
    POL: 'Numer KRS',
    PRT: 'Número de Registo Comercial',
    QAT: 'رقم التسجيل التجاري',
    ROU: 'Număr de înregistrare la Registrul Comerțului',
    SRB: 'Matični broj',
    SVK: 'IČO',
    SVN: 'Matična številka',
    SWE: 'Organisationsnummer',
    TUR: 'Ticaret Sicil Numarası',
    UKR: 'ЄДРПОУ',
};
